import { render } from "./FlashCardView.vue?vue&type=template&id=35b6dd18&scoped=true"
import script from "./FlashCardView.vue?vue&type=script&lang=js"
export * from "./FlashCardView.vue?vue&type=script&lang=js"

import "./FlashCardView.vue?vue&type=style&index=0&id=35b6dd18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b6dd18"]])

export default __exports__